module.exports = __webpack_public_path__ + "static/assets/2db38a5ffab5882c36fcb50606b4fad6.svg";